import { z } from 'zod';
import { moneySchema } from '../money';

/**
 * Projekt-Wirtschaftlichkeit (Read-Model): Auftragswert vs. Ist-Kosten vs.
 * Fakturierung vs. Zahlungseingang — die zentrale Anlagenbau-Kennzahl je Projekt.
 * Alle Beträge in Mikro-Einheiten (Money, §6); Netto außer `paid` (Zahlungen
 * gehen als Brutto-Zahlungseingang auf die Rechnungen ein).
 */
const currencySchema = z.enum(['EUR', 'USD', 'CHF']);

/** Quelle des Auftragswerts: ORDER-Belege, Projekt-Stammfeld oder gar keine Angabe. */
export const orderValueSourceSchema = z.enum(['ORDERS', 'PROJECT', 'NONE']);
export type OrderValueSource = z.infer<typeof orderValueSourceSchema>;

export const projectEconomicsResponseSchema = z.object({
  projectId: z.string().uuid(),
  currency: currencySchema,
  /** Auftragswert netto: Σ nicht-stornierter ORDER-Belege; Fallback: Projekt-Stammfeld. */
  orderValue: moneySchema,
  orderValueSource: orderValueSourceSchema,
  /** Ist-Kosten gesamt (Material-Ist + Stunden-Ist aus dem Controlling, ADR 0016). */
  costsActual: moneySchema,
  /** Fakturiert netto: Σ nicht-stornierter INVOICE + ADVANCE_INVOICE + FINAL_INVOICE. */
  invoiced: moneySchema,
  /** Zahlungseingang (brutto) auf die fakturierten Belege. */
  paid: moneySchema,
  /** Restmarge = Auftragswert − Ist-Kosten (negativ = Projekt im Minus). */
  margin: moneySchema,
  /** Marge in % vom Auftragswert (1 Nachkommastelle); null, wenn Auftragswert 0. */
  marginPct: z.number().nullable(),
  /** Fakturierungsgrad in % vom Auftragswert; null, wenn Auftragswert 0. */
  invoicedPct: z.number().nullable(),
  /** Offen zu fakturieren = Auftragswert − fakturiert (negativ = überfakturiert). */
  openToInvoice: moneySchema,
});
export type ProjectEconomicsResponse = z.infer<typeof projectEconomicsResponseSchema>;
